import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo-cotify-horizontal-negro.png";
import "./WelcomeScreen.css";

const panelUrl = process.env.REACT_APP_PANEL_URL;

const HOW_IT_WORKS_STEPS = [
  "Ubicación, operación y tipo de propiedad.",
  "Características y amenities relevantes.",
  "Comparables, ajuste e informe para el cliente.",
];

const WelcomeScreen = () => {
  const navigate = useNavigate();
  const [helpOpen, setHelpOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    const resumeSid = sessionStorage.getItem("resume_session");
    if (token && resumeSid) {
      navigate("/home");
    }
  }, [navigate]);

  const handleStart = () => {
    navigate("/property-form");
  };

  const handleBackToHome = () => {
    window.location.href = `${panelUrl}`;
  };

  return (
    <div className="welcome-screen">
      <img src={logo} alt="Cotify" className="welcome-screen__logo" />
      <h1 className="welcome-screen__title">
        ¿Estás listo para crear una tasación?
      </h1>

      <div className="welcome-screen__actions">
        <Button
          label="Volver al inicio"
          className="welcome-btn welcome-btn--secondary"
          onClick={handleBackToHome}
        />
        <Button
          label="Comencemos"
          className="welcome-btn welcome-btn--primary"
          onClick={handleStart}
        />
      </div>

      <button
        type="button"
        className="welcome-screen__help-trigger"
        onClick={() => setHelpOpen(true)}
      >
        <i className="pi pi-question-circle" aria-hidden="true" />
        Cómo funciona
      </button>

      <Sidebar
        visible={helpOpen}
        position="right"
        onHide={() => setHelpOpen(false)}
        className="welcome-help-drawer"
        showCloseIcon
        dismissable
        modal
        aria-label="Cómo funciona la tasación"
      >
        <div className="welcome-help-drawer__body">
          <div className="welcome-help-drawer__header">
            <span className="welcome-help-drawer__icon" aria-hidden="true">
              <i className="pi pi-file-edit" />
            </span>
            <div>
              <p className="welcome-help-drawer__eyebrow">Tasación</p>
              <h2 className="welcome-help-drawer__title">Cómo funciona</h2>
            </div>
          </div>

          <p className="welcome-help-drawer__lead">
            Estimá un valor defendible usando ubicación, características y comparables
            reales del mercado.
          </p>

          <ol className="welcome-help-drawer__steps">
            {HOW_IT_WORKS_STEPS.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>

          <div className="welcome-help-drawer__tip">
            <i className="pi pi-info-circle" aria-hidden="true" />
            <span>Cuanto más precisa la carga, mejores los comparables.</span>
          </div>
        </div>
      </Sidebar>
    </div>
  );
};

export default WelcomeScreen;
